export function show_time(value) {
  if (value) {
    return new Date(value).toLocaleString('en-GB', { hour12: false });
  }
}